var _path, _circle, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPresenter = function SvgPresenter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "presenter_svg__st0",
    d: "M23.3 9H20c.4.9.6 1.9.6 3 0 4.7-3.8 8.5-8.5 8.5S3.5 16.7 3.5 12c0-1.1.2-2.1.6-3H.7c-.4 0-.7.3-.7.7v11.5C0 22.8 1.2 24 2.7 24h18.5c1.5 0 2.7-1.2 2.7-2.7V9.7c.1-.4-.2-.7-.6-.7zM7.3 5V.7c0-.4-.4-.7-.8-.7H2.7C1.2 0 0 1.2 0 2.7v4c0 .4.3.7.7.7h4.1c.6-.9 1.5-1.8 2.5-2.4zM12 3.5c1.2 0 2.2.2 3.2.6V1c0-.6-.5-1-1-1H9.8c-.6 0-1 .5-1 1v3.1c1-.4 2-.6 3.2-.6zM21.3 0h-3.8c-.4 0-.7.3-.7.7V5c1 .7 1.8 1.5 2.5 2.5h4.1c.4 0 .7-.3.7-.7V2.7C24 1.2 22.8 0 21.3 0z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "presenter_svg__st0",
    cx: 14.4,
    cy: 9.1,
    r: 2.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "presenter_svg__st0",
    d: "M14.4 13h-.7s-1.4.3-2.7 0c-.9-.3-1.4-.5-2.1-1l-1-4.3c-.1-.5-.5-.7-.8-.6-.4.1-.6.4-.5.8l.9 3.6c-.3.1-.5.3-.7.5-.5.6-.4 1.5.2 2 1.1.9 1.9 1.3 3.3 1.7 0 0 1 .3 1 .7v2.8h.7c2.3 0 4.3-1.1 5.6-2.7v-.7c0-1.5-1.4-2.8-3.2-2.8z"
  })));
};
export default SvgPresenter;